import axios from '../http'

function query(data) {
    return axios.post('/event/boatLane/query', data);
}

function get(id) {
    return axios.get('/event/boatLane/get?id=' + id);
}

function choose(data) {
    return axios.post('/event/boatLane/choose', data);
}

function batchChoose(data, lane) {
    return axios.post('/event/boatLane/batchChoose?lane='+lane, data);
}


function adjust(data) {
    return axios.post('/event/boatLane/adjust', data);
}


function batchConfirm(data) {
    return axios.post('/event/boatLane/batchConfirm', data);
}

export default {
    query,
    get,
    choose,
    adjust,
    batchChoose,
    batchConfirm
}